import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Switch } from '@/components/ui/switch';
import { PROPERTY_TYPES } from '@/lib/constants';
// @ts-ignore - TODO: Fix this TypeScript error
import type { Property } from '@/lib/types';

interface PropertyFormProps {
  property?: Property | null;
  onSubmit: (data: Partial<Property>) => void;
}

export function PropertyForm({ property, onSubmit }: PropertyFormProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>{property ? 'Edit Property' : 'Add New Property'}</CardTitle>
      </CardHeader>
      <CardContent>
        <form onSubmit={(e) => {
          e.preventDefault();
          // Handle form submission
        }} className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="name">Property Name</Label>
            <Input
              id="name"
              defaultValue={property?.name}
              placeholder="Enter property name"
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="address">Address</Label>
            <Input
              id="address"
              defaultValue={property?.address}
              placeholder="Enter property address"
            />
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label>Type</Label>
              <Select defaultValue={property?.type}>
                <SelectTrigger>
                  <SelectValue placeholder="Select type" />
                </SelectTrigger>
                <SelectContent>
                  {PROPERTY_TYPES.map((type) => (
                    <SelectItem key={type.value} value={type.value}>
                      {type.label}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>

            <div className="space-y-2">
              <Label htmlFor="size">Size (sq.ft.)</Label>
              <Input
                id="size"
                type="number"
                defaultValue={property?.size}
                placeholder="Enter property size"
              />
            </div>
          </div>

          <div className="space-y-2">
            <Label htmlFor="units">Number of Units</Label>
            <Input
              id="units"
              type="number"
              defaultValue={property?.units}
              placeholder="Enter number of units"
            />
          </div>

          <div className="space-y-2">
            <h3 className="text-sm font-medium mb-2">Main Contact</h3>
            <div className="grid grid-cols-3 gap-4">
              <Input
                placeholder="Contact Name"
                defaultValue={property?.mainContact.name}
              />
              <Input
                type="tel"
                placeholder="Phone Number"
                defaultValue={property?.mainContact.phone}
              />
              <Input
                type="email"
                placeholder="Email Address"
                defaultValue={property?.mainContact.email}
              />
            </div>
          </div>

          <div className="flex items-center justify-between">
            <Label htmlFor="status">Active Status</Label>
            <Switch
              id="status"
              defaultChecked={property?.status === 'active'}
            />
          </div>

          <Button type="submit" className="w-full">
            {property ? 'Update Property' : 'Add Property'}
          </Button>
        </form>
      </CardContent>
    </Card>
  );
}